import {type DataTypeProvider} from '@devexpress/dx-react-grid';

import {OptixCheckbox} from '../../../checkbox/OptixCheckbox';

export function OptixTableDataTypeBooleanCheckboxFormatter({
  value,
}: DataTypeProvider.ValueFormatterProps): JSX.Element {
  return <OptixCheckbox checked={value} disabled />;
}
